import React, { useState, useEffect } from "react"
import { useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { useTranslation } from "next-i18next"
import { printElement } from "@/components/PartsViewer/v2/utils"
import { getPartList } from "@/store/features/pdpSlice"
import { getTranslations } from "@/components/PartsViewer/v2/localization"
import PrintPage from "@/components/PartsViewer/v2/PrintPage/index"
import Style from "@/components/PartsViewer/v2/PrintWindow/index.module.scss"

const PrintWindow = props => {
  const { files, productId } = props
  const dispatch = useDispatch()
  const [metadata, setMetadata] = useState(null)
  const [metadataPromise, setMetadataPromise] = useState(null)
  const [printItems, setPrintItems] = useState([])
  const [selected, setSelected] = useState({})
  const { t } = useTranslation("common")
  const { printDiagrams, printAllText, printSelectedText } = getTranslations(t)

  useEffect(() => {
    if (files) {
      setMetadataPromise(getPartInfo(files))
    }
  }, [files])

  const getPartInfo = async arg => {
    const resp = await dispatch(getPartList({ productId })).unwrap()
    const blobFileResp = await fetch(resp?.Info?.Thumbnail)
    const data = await blobFileResp?.blob()
    const imgFile = new Promise(resolve => {
      const reader = new FileReader()
      reader.onload = function (e) {
        resolve(e.target.result)
      }
      return reader.readAsDataURL(data)
    })
    await new Promise(r => setTimeout(r, 500))
    resp.Info.uri = await imgFile
    resp.SVGFiles = arg
    setMetadata(resp)
    setPrintItems(arg)
  }
  const printHandler = async () => {
    setPrintItems(metadata?.SVGFiles)
    await metadataPromise
    printElement("parts-print-content")
  }

  const handleChange = event => {
    const { value, checked } = event.target
    setSelected(prevState => {
      const key = ["key_" + value]
      const data = {
        ...prevState,
        [key]: value,
      }
      if (data[key] && !checked) {
        delete data[key]
      }
      return data
    })
  }

  const selectedPrinthandler = async (activeItem, list) => {
    const item = Object?.values(activeItem)
    if (item?.length !== 0) {
      const value = list?.filter(v => item?.includes(v.FileName))
      setPrintItems(value)
      await metadataPromise
      printElement("parts-print-content")
    }
  }
  const activeButton = Object?.values(selected)?.length
  return (
    <div className={Style.PrintModal}>
      <p className="mb-15 print-heading">{printDiagrams}</p>
      <div className="print-lists">
        {files?.map(val => (
          <label className="print-item" key={val?.id}>
            <p> {val?.title}</p>
            <input type="checkbox" value={val?.id} onChange={handleChange} />
            <span className="checkmark"></span>
          </label>
        ))}
      </div>

      <div className="print-action-buttons mt-20">
        <button
          className="print-button fs-18 fw-400 w-100"
          onClick={() => printHandler()}
        >
          {printAllText}
        </button>
        <button
          className={`print-button fs-18 fw-400 w-100 ${
            activeButton === 0 ? "disabled" : ""
          }`}
          onClick={() => selectedPrinthandler(selected, metadata?.SVGFiles)}
        >
          {printSelectedText}
        </button>
      </div>
      {printItems ? (
        <div className="hidden-print-wrapper">
          <div id="parts-print-content">
            {printItems?.map((item, index) => {
              return (
                <PrintPage
                  key={item?.id}
                  item={item}
                  metadata={metadata}
                  index={index}
                  printItems={printItems}
                />
              )
            })}
          </div>
        </div>
      ) : null}
    </div>
  )
}

PrintWindow.propTypes = {
  files: PropTypes.array.isRequired,
}
export default PrintWindow
